






















import { Component, Vue, Prop } from "vue-property-decorator";
import { Format } from "../../core/helpers/formatHelper";
import BaseSelect from "./baseSelect.vue";

@Component({
  components: { BaseSelect },
})
export default class InputSelect extends Vue {
  @Prop() cssClass!: string;
  @Prop() id!: string;
  @Prop() options!: any; // {value,label}
  @Prop() required!: boolean;
  @Prop() error!: string;
  @Prop() value!: string;

  get selectClass() {
    return this.cssClass && this.cssClass !== ""
      ? `form-input select-filter ${this.cssClass}`
      : "form-input select-filter";
  }

  handleInput(value: string) {
    this.$emit("input", value);
  }

  showRequiredLabel() {
    return (
      this.required === true &&
      ((this.value as any) === -1 || (this.value as any) === "-1") &&
      Format.IsNull(this.error)
    );
  }
}
